import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Modal, Typography, Flex, Button,Spin } from "antd"
import styles from "./index.module.css"
import PhoneIcon from "../../../../../../assets/icons/Phone.svg"
import MessageIcon from "../../../../../../assets/icons/messages.svg"
import CalendarIcon from "../../../../../../assets/icons/calendar.svg"
import GuestIcon from "../../../../../../assets/icons/guest.svg"
const { Title, Text } = Typography

export const WaiverDetailsModal = ({isShowLoading,setIsShowLoading, currentDocumentIndex, setCurrentDocumentIndex, record, open, onCancel, waiverData }) => {
  const [signaturePdfUrl, setSignaturePdfUrl] = useState([])
  const [totalRecords, setTotalRecords] = useState([])
  console.log(signaturePdfUrl, "signaturePdfUrl")
  useEffect(() => {
    if (
      (record?.documents && record.documents.length > 0) ||
      (record?.pending_waiver_submissions && record.pending_waiver_submissions.length > 0)
    ) {
      const totalRecord = [...(record?.documents || []), ...(record?.pending_waiver_submissions || [])]
      console.log(totalRecord, "totalRecordtotalRecord")
      const totalRecords = totalRecord.map((ele) => {
        return {
          signed_pdf_url: ele?.signed_pdf_url || ele?.document_url
          // document_filename:ele?.document_filename
        }
      })
      setTotalRecords(totalRecords)
      const now = new Date()
      const initialFileObjects = totalRecords.map((docItem, index) => {
        const fileName =
          docItem?.document_filename ||
          docItem?.signed_pdf_url?.split("/").pop() ||
          docItem?.document_url?.split("/").pop() ||
          "document.pdf"
        return {
          uid: `existing-${Date.now()}-${index}`,
          lastModified: now.getTime(),
          lastModifiedDate: now.toISOString(),
          name: fileName,
          type: "application/pdf",
          percent: 0,
          status: "uploading",
          url: docItem.signed_pdf_url || docItem.document_url
        }
      })
      // Load all documents
      const fetchDocuments = async () => {
        try {
          const filePromises = totalRecords.map(async (docItem, index) => {
            const fileName =
              docItem?.document_filename ||
              docItem?.signed_pdf_url?.split("/").pop() ||
              docItem?.document_url?.split("/").pop() ||
              "document.pdf"

            const response = await fetch(docItem.signed_pdf_url || docItem.document_url)
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }

            // Get the blob and create a file object
            const blob = await response.blob()
            const file = new File([blob], fileName, {
              type: blob.type || "application/pdf",
              lastModified: now.getTime()
            })

            // Create the final file object with all properties
            return {
              ...initialFileObjects[index],
              size: blob.size,
              status: "done",
              originFileObj: file
            }
          })

          const fileObjects = await Promise.all(filePromises)
          // Set PDF URLs for all documents
          const pdfObjectUrls = fileObjects.map((fileObj) => URL.createObjectURL(fileObj.originFileObj))
          setSignaturePdfUrl(pdfObjectUrls)
           setIsShowLoading(false)
          // Clean up function to revoke object URLs on unmount
          return () => {
            pdfObjectUrls.forEach((url) => URL.revokeObjectURL(url))
          }
        } catch (error) {
          console.error("Error fetching documents:", error)
          // Update file list with error state
        }
      }
      fetchDocuments()
    }
  }, [record?.documents?.length, record?.pending_waiver_submissions?.length, totalRecords?.length])
  // Use participant data from record.participants, fallback to waiverData for document info
  const participant = record && record.participants && record.participants.length > 0 ? record.participants[0] : {}

  const { first_name = "", last_name = "", full_name = null, phone_number = "", email = "", birthdate = "", age = "" } = participant

  // Use full_name if available, otherwise combine first_name and last_name
  const displayName = full_name || `${first_name} ${last_name}`.trim() || "Unknown"
  // Format birthdate if available
  const formattedBirthdate = birthdate
    ? new Date(birthdate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
      })
    : "Not provided"

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
      centered
      className={styles.waiverModal}
      closeIcon={<span className={styles.closeIcon}>×</span>}
      maskClosable={false}
    >  
      <Spin spinning={isShowLoading}>
      <div className="p-xl">
        {/* Header */}
        <div className="mb-l">
          <Title level={3} className={`${styles.title} mb-xs`}>
            Waiver
          </Title>
          <Text className={styles.subtitle}>{record?.participants?.length > 0 && displayName}</Text>
        </div>

        {/* Personal Information */}
        <div className="mb-l">
          {record?.participants?.length > 0 && (
            <Flex justify="space-between" wrap="wrap">
              <Flex vertical gap="small">
                <Flex align="center" gap="small">
                  <img src={GuestIcon} alt="guest" />
                  <Text className={styles.infoText}>{displayName}</Text>
                </Flex>

                <Flex align="center" gap="small">
                  <img src={CalendarIcon} alt="calendar" />
                  <Text className={styles.infoText}>{formattedBirthdate}</Text>
                </Flex>
              </Flex>

              <Flex vertical gap="small">
                {phone_number && (
                  <Flex align="center" gap="small">
                    <img src={PhoneIcon} alt="phone" />
                    <Text className={styles.infoText}>{phone_number}</Text>
                  </Flex>
                )}
                {email && (
                  <Flex align="center" gap="small">
                    <img src={MessageIcon} alt="email" />
                    <Text className={styles.infoText}>{email || "Not provided"}</Text>
                  </Flex>
                )}
              </Flex>
            </Flex>
          )}
        </div>

        {/* Document Preview */}
        <div className={`${styles.documentPreview} p-m`}>
          <Title level={4} className={`${styles.documentTitle} mb-m`}>
            Document Preview
          </Title>
          {signaturePdfUrl.length > 0 && (
            <div className={styles.pdfPreviewContainer}>
              <div className={styles.pdfViewer}>
                <Flex align="center" justify="end">
                  {currentDocumentIndex + 1} of {signaturePdfUrl.length} documents
                </Flex>
                <div className={`mb-xs ${styles.documentTitle}`}>
                  Document {currentDocumentIndex + 1}:{" "}
                  {totalRecords?.[currentDocumentIndex]?.signed_pdf_url?.split("/").pop() || `Document ${currentDocumentIndex + 1}`}
                </div>
                <object data={signaturePdfUrl[currentDocumentIndex]} type="application/pdf" className={styles.pdfObject}>
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Unable to display PDF preview. Please download the file to view it.
                  </div>
                </object>
              </div>
            </div>
          )}
        </div>
        <Flex justify="end" gap={12}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setCurrentDocumentIndex(currentDocumentIndex - 1)}
            disabled={currentDocumentIndex === 0}
          >
            Previous
          </Button>
          <Button
            color="primary"
            variant="solid"
            onClick={() => setCurrentDocumentIndex(currentDocumentIndex + 1)}
            disabled={currentDocumentIndex === signaturePdfUrl.length - 1}
          >
            Next
          </Button>
        </Flex>
      </div>
      </Spin>
    </Modal>
  )
}

WaiverDetailsModal.propTypes = {
  currentDocumentIndex: PropTypes.number.isRequired,
  setCurrentDocumentIndex: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  waiverData: PropTypes.shape({
    name: PropTypes.string,
    dateOfBirth: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    documentTitle: PropTypes.string,
    documentContent: PropTypes.string
  })
}
